// The purpose of this file is for handling the
// registration of Font Awesome icons
import { faPen } from '@fortawesome/free-solid-svg-icons/faPen';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons/faMinusCircle';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';
import { faThList } from '@fortawesome/free-solid-svg-icons/faThList';
import { faTh } from '@fortawesome/free-solid-svg-icons/faTh';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons/faGraduationCap';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faCalendar } from '@fortawesome/free-solid-svg-icons/faCalendar';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons/faUserCircle';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faSadTear } from '@fortawesome/free-solid-svg-icons/faSadTear';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons/faBriefcase';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faBuilding } from '@fortawesome/free-solid-svg-icons/faBuilding';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons/faSignInAlt';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay';
import { faVideo } from '@fortawesome/free-solid-svg-icons/faVideo';
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons/faShieldAlt';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons/faFileAlt';
import { faFileImage } from '@fortawesome/free-solid-svg-icons/faFileImage';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons/faFilePdf';
import { faFileWord } from '@fortawesome/free-solid-svg-icons/faFileWord';
import { faFilePowerpoint } from '@fortawesome/free-solid-svg-icons/faFilePowerpoint';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons/faFileExcel';
import { faRedo } from '@fortawesome/free-solid-svg-icons/faRedo';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons/faCalendarCheck';
import { faCalendarPlus } from '@fortawesome/free-solid-svg-icons/faCalendarPlus';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons/faCalendarDay';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt';
//Would rather have calendar-alt from free-regular-svg-icons, but didn't get this to work even after installing the package in package.json..
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt';
import { faGlobeAmericas } from '@fortawesome/free-solid-svg-icons/faGlobeAmericas';

export default library => {
    library.add(faPen);
    library.add(faTrash);
    library.add(faTimes);
    library.add(faSearch);

    library.add(faCheckCircle);
    library.add(faTimesCircle);
    library.add(faMinusCircle);

    library.add(faMapMarkerAlt);
    library.add(faCaretDown);
    library.add(faChevronDown);
    library.add(faChevronUp);
    library.add(faChevronRight);
    library.add(faChevronLeft);

    library.add(faThList);
    library.add(faTh);
    library.add(faBars);

    library.add(faGraduationCap);
    library.add(faEnvelope);
    library.add(faCalendar);
    library.add(faCalendarCheck);
    library.add(faCalendarPlus);
    library.add(faCalendarDay);
    library.add(faCalendarAlt);

    library.add(faUserCircle);
    library.add(faSignOutAlt);
    library.add(faSignInAlt);
    library.add(faFilter);

    library.add(faExclamationCircle);
    library.add(faSadTear);
    library.add(faClock);

    library.add(faSave);
    library.add(faBriefcase);
    library.add(faExclamationTriangle);

    library.add(faCheck);
    library.add(faArrowLeft);
    library.add(faArrowRight);
    library.add(faArrowUp);
    library.add(faPlus);

    library.add(faExclamation);
    library.add(faUser);
    library.add(faBuilding);

    library.add(faLock);
    library.add(faPlay);
    library.add(faVideo);

    library.add(faHeart);

    library.add(faShieldAlt);
    library.add(faSpinner);
    library.add(faFileAlt);
    library.add(faFileImage);
    library.add(faFilePdf);
    library.add(faFileWord);
    library.add(faFilePowerpoint);
    library.add(faFileExcel);

    library.add(faRedo);
    library.add(faDownload);

    library.add(faLink);
    library.add(faExternalLinkAlt);

    library.add(faGlobeAmericas);
};
